export default {
    'Close menu': 'Menü schließen',
    'Close submenu': 'Untermenü schließen',
    'Open submenu': 'Untermenü öffnen',
    'Toggle submenu': 'Untermenü wechseln'
};



//////////////////
// WEBPACK FOOTER
// ../~/mmenu-js/dist/core/screenreader/translations/de.js
// module id = 102
// module chunks = 0